export const GET_ALL_USERS = () => `/data/users.json`;
export const GET_DEMO_USER = (id) => `/data/demo_user.json`;
export const GET_ALL_CALIBERS = () => `/data/calibers.json`;
export const GET_ALL_PRODUCTS = () => `/data/products.json`;
export const GET_ALL_ORDER_STATUSES = () => `/data/orderStatuses.json`;